import { useRef } from 'react';

import {
  createCategoryTrackEvent,
  trackG4CategoryClick,
} from '@/common/analytics/gtm/Homepage/categoriesAnalytics';
import { DefaultTrackPromotionEvent } from '@/common/analytics/gtm/shared/trackViewPromotion';
import { ResolutionsSrcSet, StaticImage } from '@/common/constants/displateRoutes';
import { useImpression } from '@/common/impressions';

import { Category } from './Category.data';
import styles from './category.module.scss';

interface CategoryItemProps {
  category: Category;
  index: number;
}

const CategoryItem = ({ category, index }: CategoryItemProps) => {
  const assetPath = '/images/homepage/categories/';
  const listItemRef = useRef(null);

  const { setOnHold } = useImpression<DefaultTrackPromotionEvent>({
    ref: listItemRef,
    message: createCategoryTrackEvent(category, index + 1),
    initialOnHold: true,
  });

  const handleCategoryClick = () => {
    const event = createCategoryTrackEvent(category, index + 1);
    trackG4CategoryClick(event);
  };

  return (
    <li
      className={styles.categoriesItem}
      data-testid={`category-item-${category.image}`}
      ref={listItemRef}
    >
      <a href={category.url} onClick={handleCategoryClick}>
        <span className={styles.label}>{category.label}</span>
        <picture>
          <source
            srcSet={ResolutionsSrcSet({
              x1: StaticImage(`${assetPath}${category.image}.avif`),
              x2: StaticImage(`${assetPath}${category.image}@2x.avif`),
            })}
            type="image/avif"
          />
          <source
            srcSet={ResolutionsSrcSet({
              x1: StaticImage(`${assetPath}${category.image}.webp`),
              x2: StaticImage(`${assetPath}${category.image}@2x.webp`),
            })}
            type="image/webp"
          />
          <source
            srcSet={ResolutionsSrcSet({
              x1: StaticImage(`${assetPath}${category.image}.jpg`),
              x2: StaticImage(`${assetPath}${category.image}@2x.jpg`),
            })}
            type="image/jpeg"
          />
          <img
            alt={category.label}
            className={styles.image}
            loading="lazy"
            onLoad={() => setOnHold(false)}
            src={StaticImage(`${assetPath}${category.image}.jpg`)}
          />
        </picture>
      </a>
    </li>
  );
};

export default CategoryItem;
